// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Zp-z","breadcrumbForward":"_p-z","breadcrumbBack":"aq-z","selected":"bq-z"};